/* prettier-ignore */
/**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */
//Italian (Italy)
export default {
  'fabric.emoji.add.custom.emoji.label': 'Aggiungi la tua emoji',
  'fabric.emoji.add.label': 'Aggiungi emoji',
  'fabric.emoji.cancel.label': 'Annulla',
  'fabric.emoji.categories.label': 'Scegli una categoria di emoji',
  'fabric.emoji.categories.search.results': 'Risultati di ricerca',
  'fabric.emoji.category.activity': 'Attività',
  'fabric.emoji.category.all.uploads': 'Tutti i caricamenti',
  'fabric.emoji.category.flags': 'Bandiere',
  'fabric.emoji.category.foods': 'Cibo e bevande',
  'fabric.emoji.category.frequent': 'Usate di frequente',
  'fabric.emoji.category.nature': 'Natura',
  'fabric.emoji.category.objects': 'Oggetti',
  'fabric.emoji.category.people': 'Persone',
  'fabric.emoji.category.places': 'Viaggi e luoghi',
  'fabric.emoji.category.productivity': 'Produttività',
  'fabric.emoji.category.symbols': 'Simboli',
  'fabric.emoji.category.user.uploads': 'I tuoi caricamenti',
  'fabric.emoji.choose.file.screenReaderDescription':
    "Scegli un file per l'emoji. JPG, PNG o GIF. Dimensioni massime: 1 MB",
  'fabric.emoji.choose.file.title': 'Scegli file',
  'fabric.emoji.delete.description': 'Tutte le istanze esistenti di questa emoji saranno sostitute da {emojiShortName}',
  'fabric.emoji.delete.label': 'Cancella',
  'fabric.emoji.delete.screenreader.tooltip': "Per eliminare l'emoji {shortName}, premi Backspace",
  'fabric.emoji.delete.title': 'Cancella emoji',
  'fabric.emoji.delete.tooltip': 'Elimina',
  'fabric.emoji.emojipicker.emoi.roledescription': 'pulsante emoji',
  'fabric.emoji.emojipicker.error': 'Errore.',
  'fabric.emoji.error.delete.failed': 'Cancellazione non riuscita',
  'fabric.emoji.error.image.too.big': 'L’immagine selezionata è superiore a un 1 MB',
  'fabric.emoji.error.invalid.image': 'L’immagine selezionata non è valida',
  'fabric.emoji.error.upload.failed': 'Caricamento non riuscito',
  'fabric.emoji.error.upload.timeout': 'Timeout del caricamento',
  'fabric.emoji.image.requirements': 'JPG, PNG o GIF. Dimensione massima 1 MB.',
  'fabric.emoji.name.ariaLabel': 'Immetti un nome per il nuovo emoji',
  'fabric.emoji.picker': 'Selettore di emoji',
  'fabric.emoji.pickerlist.grid': '{showSearchResults, select, true {Risultati della ricerca} other {Emoji}}',
  'fabric.emoji.pickerlist.tabpanel': "Pannello delle azioni e dell'elenco degli emoji",
  'fabric.emoji.placeholder': 'ad es. ciao',
  'fabric.emoji.preview': 'La tua nuova emoji {emoji} è fantastica',
  'fabric.emoji.preview.title': 'Anteprima',
  'fabric.emoji.retry.label': 'Riprova',
  'fabric.emoji.search.label': 'Nome emoji',
  'fabric.emoji.search.placeholder': 'Ricerca',
  'fabric.emoji.search.status': 'Visualizzazione di tutte le emoji',
  'fabric.emoji.select.skin.list.ariaLabel': 'Selettore del tono della pelle',
  'fabric.emoji.select.skin.tone.ariaLabel': 'Scegli il tono della tua pelle; è selezionato {selectedTone}',
};
